import styled from "styled-components";

import { grayScale, red } from "@enkor/design/colors";
import { Typo } from "@enkor/design/components";
import BaseBottomSheet from "@domains/common/views/modal/BaseBottomSheet/BaseBottomSheet";

const HEADER_HEIGHT = 40;

export const BottomSheetContainer = styled(BaseBottomSheet)`
  width: 100%;
  height: 80vh;
  min-height: 270px;
  max-height: 590px;
  padding: 16px;
  padding-bottom: 48px;
  border: 1px solid ${grayScale.main};
  border-radius: 16px 16px 0px 0px;

  background-color: ${grayScale[300]};
`;

export const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  height: ${HEADER_HEIGHT}px;
  margin-bottom: 16px;
  padding: 8px 0 24px;
  border-bottom: 1px solid ${grayScale.main};
`;

export const ScrollWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;

  height: calc(100% - ${HEADER_HEIGHT}px);

  /* 스크롤바 전체 스타일 */

  &::-webkit-scrollbar {
    width: 4px; /* 스크롤바의 너비 */
    height: 12px;
  }

  /* 스크롤바 트랙(경로) 스타일 */

  &::-webkit-scrollbar-track {
    background-color: ${grayScale[100]}; /* 스크롤바 트랙의 배경 색상 */
  }

  /* 스크롤바 핸들(이동하는 부분) 스타일 */

  &::-webkit-scrollbar-thumb {
    border: none; /* 스크롤바 핸들의 테두리 (트랙과 같은 색상으로 설정하여 핸들만 보이게) */
    border-radius: 6px; /* 스크롤바 핸들의 모서리 둥글기 */

    background-color: ${grayScale.white}; /* 스크롤바 핸들의 배경 색상 */
  }

  /* 스크롤바 핸들:hover 스타일 */

  &::-webkit-scrollbar-thumb:hover {
    background: ${grayScale.white}; /* 스크롤바 핸들의 배경 색상 (hover 시) */
  }
`;

export const Title = styled(Typo.Text)`
  color: ${grayScale.white};
`;

export const CancelButton = styled.button`
  color: ${grayScale.white};
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
`;

export const WarningIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 40px;
  height: 40px;

  border-radius: 50%;
  background-color: ${red.main};
`;

export const TextareaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  width: 100%;
  padding: 24px 0 40px;
`;

export const PolicyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const TextareaDescription = styled(Typo.Text)`
  color: ${grayScale.white};
`;

export const RefundPolicyInfo = styled.ul`
  margin-left: 28px;
`;

export const RefundPolicyItem = styled.li`
  list-style: disc;

  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  color: ${grayScale.white};
`;

export const SubmitButton = styled.button`
  width: 100%;
  height: 48px;
  margin-top: auto;
  padding: 13px 0;
  border-radius: 8px;

  background-color: ${red.main};

  color: ${grayScale.white};
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;

  transition: all 0.3s ease-in-out;

  &:disabled {
    background-color: ${grayScale.main};

    color: ${grayScale[500]};

    cursor: default;
  }
`;
